import { CHESS_ENGINE } from "vue-chess-shared/constants";

const ENGINE_EVENTS = {
  MOVE: "move",
};

export default class AiWorker {
  // Private props
  #engineWorker = null;
  #event = "";
  #isReady = false;
  #engineName = null;

  // Public props
  #depth = 12; // default depth is 12

  onReady = null;
  onMoveComplete = null;

  setDepth(depth) {
    this.#depth = depth;
    // console.log("updated:", this.#engineName, ". Level:", this.#depth);
  }

  setEngine(engineName) {
    this.#engineName = engineName;

    if (!this.#engineName) {
      return;
    }

    this.#isReady = false;
    this.init();
  }

  isReady() {
    return this.#isReady;
  }

  init() {
    this.loadEngine();

    // start UCI
    this.send("uci");
    // start new game
    this.send("ucinewgame");
    // set new game position
    this.send("position startpos");
    // start search
    this.send("go depth " + 1);
  }

  engineOnMessage(e) {
    let response = e.data;

    if (
      response.startsWith("bestmove") ||
      response.startsWith("Unknown command")
    ) {
      if (!this.#isReady) {
        this.#isReady = true;
        if (this.onReady) this.onReady();
      }

      if (this.#event === ENGINE_EVENTS.MOVE) {
        // console.log(
        //   `#AiWorker ${this.#engineName} - ${this.#depth} response:`,
        //   response
        // );
        this.#event = null;
        const bestMove = response.split(/ +/)[1];
        const ponder = response.split(/ +/)[3];
        if (this.onMoveComplete) {
          this.onMoveComplete({ bestMove, ponder });
        }
      }
    }
  }

  engineOnError() {
    this.onMoveComplete({});
  }

  send(cmd) {
    this.#engineWorker.postMessage(cmd);
  }

  generateMove(fen) {
    this.#event = ENGINE_EVENTS.MOVE;
    this.send(`position fen ${fen}`); // update fen
    this.send("go depth " + this.#depth);
  }

  loadEngine() {
    let engineFile = "";
    switch (this.#engineName) {
      case CHESS_ENGINE.STOCKFISH:
        engineFile = "js/stockfish6.js";
        break;
      case CHESS_ENGINE.LOZZA:
        engineFile = "js/lozza.js";
        break;
      case CHESS_ENGINE.P4WN:
        engineFile = "js/p4wn.js";
        break;
      default:
        engineFile = "js/stockfish6.js";
        break;
    }
    console.log("loaded:", engineFile);
    this.#engineWorker = new Worker(engineFile);
    this.#engineWorker.onmessage = this.engineOnMessage.bind(this);
    this.#engineWorker.onerror = this.engineOnError.bind(this);
  }

  terminate() {
    if (this.#engineWorker) this.#engineWorker.terminate();
  }
}
